export default __webpack_public_path__ + "static/media/game_logo.min.cc3b93d3.png";